<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-row class="pl-3">
              <v-col cols="12" class="content_category rounded-lg d-flex">
                <h3 class="mt-2">Banner</h3>
                <v-btn
                  class="ml-5 mb-5"
                  color="primary"
                  @click="addBanner()"
                >
                  Thêm
                </v-btn>
              </v-col>
              <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index"> </form-link>
              </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col class="mx-1">
                <v-row>
                    <h3 class="ml-3 mt-2">Tính chất</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addProperty()"
                    >
                      Thêm
                    </v-btn>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                    <div
                      class="content_property mt-5 rounded-lg"
                      v-for="(item, index) in properties"
                      :key="index"
                    >
                      <v-col>
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn color="primary" @click="clearProperty(index)">
                            Xóa
                          </v-btn>
                        </div>
                      </v-col>

                      <v-col cols="12">

                        <v-autocomplete
                          v-model="item.category_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="categories"
                          label="Danh mục"
                          placeholder="Chọn category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-color-picker
                          height="350px"
                          width="400px"
                          v-model="item.color"
                          swatches-max-height="200"
                        ></v-color-picker>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category rounded-lg">
              <v-col class="mx-1">
                <v-row>
                  <h3 class="ml-3 mt-2">Bộ sưu tập</h3>
                  <v-btn
                    class="ml-5 mb-5"
                    color="primary"
                    @click="addCollection()"
                  >
                    Thêm
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                    <div
                      class="content_property mt-5 rounded-lg"
                      v-for="(item, index) in collections"
                      :key="index"
                    >
                      <v-col>
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn color="primary" @click="clearCollection(index)">
                            Xóa
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="item.title"
                          background-color="#EDF2F7"
                          filled
                          item-text="name"
                          item-value="id"
                          label="Giới thiệu"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-col cols="6">
                          <v-file-input
                            label="Ảnh"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileSelectCollection($event, index)"
                          ></v-file-input>
                        </v-col>
                        <v-col>
                          <v-img
                            :src="item.photo_url_path"
                          ></v-img>
                          <v-text-field v-if="item.photo_url_path"
                              background-color="#EDF2F7"
                              filled
                              label="Alt ảnh"
                              v-model="item.alt_image"
                              placeholder="Nhập alt"
                          ></v-text-field>
                        </v-col>
                      </v-col>
                      <v-col cols="12">
                        <div class="mx-2">
                          <v-row>
                            <v-row class="mb-3">
                              <h3 class="ml-6 mt-2">Category</h3>
                              <v-btn
                                class="ml-5 mb-5"
                                color="primary"
                                @click="addCategory(index)"
                              >
                                Thêm
                              </v-btn>
                            </v-row>
                          </v-row>
                          <v-divider></v-divider>
                          <div
                            v-for="(item, indexChil) in item.category_ids"
                            :key="indexChil"
                          >
                            <v-select
                              outlined
                              v-model="item.id"
                              :items="categories"
                              item-text="name"
                              item-value="id"
                              dense
                              append-icon="mdi-delete"
                              @click:append="clearCategory(indexChil, index)"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import {
  GET_LIST_CONFIG_BLANCO,
  UPDATE_LIST_CONFIG_BLANCO,
  UPLOAD_BLANCO_IMAGE,
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";

export default {
  components: { FormLink },
  data() {
    return {
      type_id: null,
      list_ids: [],
      select_type: null,
      banners: [],
      banner: {
          alt_image: "",
          alt_image_mobile: "",
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      type: null,
      object_id: null,
      list_type: [
        {
          id: "category",
          text: "category",
        },
        {
          id: "brand",
          text: "brand",
        },
        {
          id: "tag",
          text: "tag",
        },
      ],
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",

      // src_banner_mobile: "",
      // src_banner_desktop: "",
      category: {
        id: -1,
      },
      properties: [],
      collections: [],
      collection: {
        title: "",
        category_ids: [],
        photo_url: "",
      },

      page: "Quản lý Blanco",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Blanco",
          disabled: true,
        },
      ],
      errors: 0,
      text_seo: "",
      SEO: [],
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      config_blanco: "config_blanco",
      //   category: "categoryDetail",
      //   brands: "brands",
      //   tags: "tags",
      //   seos: "seos",
    }),
  },
  watch: {
    config_blanco(val) {
      this.properties = val.properties;
      this.collections = val.collection;
      this.banners = val.banner;
      // this.src_banner_mobile = val.banner.photo_url_mobile_path;
      // this.src_banner_desktop = val.banner.photo_url_path;
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_BLANCO}`);
 
    // await this.$store.dispatch(`${GET_LIST_TAG}`);
  },
  mounted() {
    
  },
  methods: {
    addProperty() {
      this.config_blanco.properties.push({
        category_id: null,
        color: ""
      });
    },
    clearProperty(i) {
      this.config_blanco.properties.splice(i, 1);
      this.$forceUpdate();
    },
    addCollection() {
      this.collection.category_ids = [];
      this.config_blanco.collection.push({
        title: this.collection.title,
        category_ids: this.collection.category_ids,
        photo_url: this.collection.photo_url,
      });
    },
    clearCollection(i) {
      this.config_blanco.collection.splice(i, 1);
      this.$forceUpdate();
    },
    addCategory(index) {
      this.config_blanco.collection[index].category_ids.push({
        id: this.category.id,
      });
    },
    clearCategory(indexChil, indexParent) {
      this.config_blanco.collection[indexParent].category_ids.splice(
        indexChil,
        1
      );

      this.$forceUpdate();
    },
    fileSelectCollection(event, index) {
      // const _this = this;
      if (!event) {
        // this.src_banner_desktop = '';
        // this.category.banner_media = {};
        console.log(2);
      } else {
        this.collection.photo_url = "";
        // this.collections[index].image = "";
        this.image = event;
        this.collections[index].photo_url = URL.createObjectURL(
          this.image
        );
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store
          .dispatch(`${UPLOAD_BLANCO_IMAGE}`, formData)
          .then((data) => {
            if (data && data.data && data.data.data) {
              data.data.data.forEach((element) => {
                console.log(element);
                let data = {
                  path: element.path,
                  url: element.url,
                };
                this.collections[index].photo_url = data.path;
                this.collections[index].photo_url_path = data.url;
              });
            }
          });
      }
    },
    save() {
      let _this = this;
      let body = {
        banner: this.banners,
        collection: this.collections,
        properties: this.properties,
      };
      if (body.banner.type == 1) {
        body.banner.link.url = null;
      }
      if (body.banner.type == 2) {
        body.banner.link.object_id = null;
        body.banner.link.type = null;
      }
      this.$store
        .dispatch(`${UPDATE_LIST_CONFIG_BLANCO}`, body)
        .then((data) => {
          if (data.data.status === 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            _this.$store.dispatch(`${GET_LIST_CONFIG_BLANCO}`);
          } else {
            alert(data.data.errors);
          }
        });
    },
    addBanner() {
      this.banners.push({
        alt_image: this.banner.alt_image,
        alt_image_mobile: this.banner.alt_image_mobile,
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>